import i18n from 'i18next';

import { hasUtcDTStartInLocal } from 'utils/dateTime';

export const IS_NO_PLANS = -2;
export const IS_END = -1;
export const IS_OFFLINE = 0;
export const IS_ONLINE = 1;
export const IS_SUSPEND = 2;

export function getStatusLabel(status, promoStartDate) {
    switch (status) {
        case IS_OFFLINE:
            return i18n.t('label.no_publish');
        case IS_ONLINE:
            return Boolean(promoStartDate) && hasUtcDTStartInLocal(promoStartDate)
                ? i18n.t('label.is_published')
                : i18n.t('label.is_queue_publish');
        case IS_SUSPEND:
            return i18n.t('label.is_suspended');
        case IS_END:
            return i18n.t('label.is_end');
        default:
            return '';
    }
}

// 詳情請見 Ticket [NFV-2746]
// 以下這些全都是兩個模組架構下的特例 wording 處理 = =
export function getStatusLabelWhenPromoStructureIsTwoPromo({
    primaryStatus,
    secondaryStatus,
    primaryStartDate,
    secondaryStartDate
} = {}) {
    const DEFAULT_CASE = 'DEFAULT_CASE';
    const PARTICULAR_CASE_WHEN_BOTH_PROMO_ONLINE = 'PARTICULAR_CASE_WHEN_BOTH_PROMO_ONLINE';

    const labelStatusHandler = {
        [DEFAULT_CASE]: (status, promoStartDate) => {
            return getIsPromoSuspendNotYetStart(status, promoStartDate)
                ? i18n.t('label.suspend_start')
                : getStatusLabel(status, promoStartDate);
        },
        [PARTICULAR_CASE_WHEN_BOTH_PROMO_ONLINE]: (status, promoStartDate, isQueuePublish) => {
            return isQueuePublish
                ? i18n.t('label.about_to_start')
                : getStatusLabel(status, promoStartDate);
        }
    };

    const isBothPromoOnline = primaryStatus === IS_ONLINE && secondaryStatus === IS_ONLINE;
    const isPrimaryPromoQueuePublish = getIsQueuePublishStatus(primaryStatus, primaryStartDate);
    const isSecondaryPromoQueuePublish = getIsQueuePublishStatus(
        secondaryStatus,
        secondaryStartDate
    );
    const isHasOnlyOneQueuePublishPromo = Boolean(
        isPrimaryPromoQueuePublish ^ isSecondaryPromoQueuePublish
    );

    let currentParticularCase = DEFAULT_CASE;
    let primaryStatusLabel = '';
    let secondaryStatusLabel = '';

    if (isBothPromoOnline) {
        currentParticularCase = isHasOnlyOneQueuePublishPromo
            ? PARTICULAR_CASE_WHEN_BOTH_PROMO_ONLINE
            : currentParticularCase;
    }

    switch (currentParticularCase) {
        case PARTICULAR_CASE_WHEN_BOTH_PROMO_ONLINE:
            primaryStatusLabel = labelStatusHandler[currentParticularCase](
                primaryStatus,
                primaryStartDate,
                isPrimaryPromoQueuePublish
            );
            secondaryStatusLabel = labelStatusHandler[currentParticularCase](
                secondaryStatus,
                secondaryStartDate,
                isSecondaryPromoQueuePublish
            );
            break;
        default:
            primaryStatusLabel = labelStatusHandler[currentParticularCase](
                primaryStatus,
                primaryStartDate
            );
            secondaryStatusLabel = labelStatusHandler[currentParticularCase](
                secondaryStatus,
                secondaryStartDate
            );
            break;
    }

    return [primaryStatusLabel, secondaryStatusLabel];
}

export function getIsPromoSuspendNotYetStart(status, promoStartDate) {
    return (
        status === IS_SUSPEND && Boolean(promoStartDate) && !hasUtcDTStartInLocal(promoStartDate)
    );
}

export function getIsQueuePublishStatus(status, promoStartDate) {
    return status === IS_ONLINE && Boolean(promoStartDate) && !hasUtcDTStartInLocal(promoStartDate);
}
